<template>
  <div>
    <header>
      <div class="header-inner">
        <div class="logo" :style="{backgroundImage: `url('${collectionImage}')` }"></div>
        <div class="company">{{company}} <span class="counter"></span></div>
      </div>
      <!-- /.header-inner -->
    </header>
    <main>

      <div class="spinner"></div>
      <!-- /.spinner -->
      <div class="image-holder"></div>
      <!-- /.image-holder -->
      <div id="timeline" class="timeline">
          <div class="timeline-segment" v-for="data in apiData" 
            :data-image="data.ImageLink.link"
            :data-time="[ data.Image.file_name, ['YYYY_MMDD_HHmmss[.JPG]', 'YYYY_MMDD_HHmmss[.jpg]']] | moment('YYYY-MM-DD hh:mm:ss A')"
          >
          <div class="timeline-segment-data">
            <p>{{ [ data.Image.file_name, ['YYYY_MMDD_HHmmss[.JPG]', 'YYYY_MMDD_HHmmss[.jpg]']] | moment('YYYY-MM-DD hh:mm:ss A') }}</p>
          </div>
          <!-- /.timeline-segment-data -->
          </div>
          <!-- /.segment -->
      </div>
      <!-- .timeline -->
      <div id="time-container" class="time-container"></div>
      <!-- /.time-container -->
      <a class="download" href="#" target="_blank" download><img src="../assets/images/download.svg" alt="Download" width="30"></a>
      <!-- /.download -->
      <date-picker @update-date="updateDate" date-format="yy-mm-dd" v-once></date-picker>
    </main>
  </div>
</template>
 
<script>

  export default {

    data() {
      var that = this;
      return {
        apiData: '',
        company: '',
        location: '',
        collectionImage: '',
        date: '',
        fullResponse: ''
      }
    },
    mounted() {
      var initEp = 'https://www.photoshelter.com/psapi/v3/gallery/'+this.$route.params.id+'?api_key=Tc6JbbBVQfA';
      var extend = {
        "KeyImage": {
          "fields": "image_id, gallery_id",
          "params": {}
        },
        "GalleryImage": {
          "fields": "image_id, gallery_id",
          "params": {
            "per_page": "100",
            "page": "1"
          }
        },
        "ImageLink": {
          "fields": "link,base",
          "params": {
            "image_size": "1920",
            "image_mode": "fit"
          }
        },
        "Image": {
          "fields": "image_id,file_name"
        },
        "Iptc": {
          "fields": "sdate"
          // "fields": "ctime"
        }
      };
      var extendStr = "extend=" + JSON.stringify(extend);
      var request = initEp + "&" + extendStr;

      axios
        .get(request)
        .then(response => {
          this.apiData = response.data.data.Gallery.GalleryImage;
          this.company = response.data.data.Gallery.name;
          this.collectionImage = response.data.data.Gallery.KeyImage.ImageLink.base;
          console.log('First Response:', response.data);
        })
        .then((response) => {
          // add first image / date on success
          var firstImage = $('.timeline-segment:first').data('image');
          var firstTime = $('.timeline-segment:first').data('time');
          $('.image-holder').css('background-image', 'url(' + firstImage + ')');
          $('.time-container').text(firstTime);
          $('.download').attr('href', firstImage);
          $('.timeline-segment:first').addClass('active');
        })

      var extend2 = {
        "KeyImage": {
          "fields": "image_id, gallery_id",
          "params": {}
        },
        "GalleryImage": {
          "fields": "image_id, gallery_id",
          "params": {
            // "per_page": "100",
            // "page": "1"
          }
        },
        "ImageLink": {
          "fields": "link, base",
          "params": {
            "image_size": "1920",
            "image_mode": "fit"
          }
        },
        "Image": {
          "fields": "image_id,file_name"
        },
        "Iptc": {
          "fields": "sdate"
          // "fields": "ctime"
        }
      };
      var extendStr2 = "extend=" + JSON.stringify(extend2);
      var request2 = initEp + "&" + extendStr2;

      axios
        .get(request2)
        .then(response => {
          console.log('Full Response: ', response.data);
          this.fullResponse = response.data;
        })

        // jQuery
        $(document).on('click', '.timeline-segment', function(){
          var image = $(this).data('image');
          var time = $(this).data('time');
          $(this).addClass('active').siblings().removeClass('active');
          $('.image-holder').animate({
            opacity: 0
            }, 500, function() {
            $('.image-holder').css('background-image', 'url(' + image + ')');
            $('.time-container').text(time);
            $('.download').attr('href', image);
            setTimeout(function(){
              $('.image-holder').animate({
                opacity: 1
              }, 500, function(){

              });
            }, 1000);
          });
        });

    },
    methods: {
      updateDate: function(selectedDate) {

        this.date = selectedDate;

        console.log('Selected date:', selectedDate);

        let initArray = this.fullResponse;

        console.log('init Array:', initArray);

        function getImgLinksByDate(initArray, date){
          return initArray
          .data
          .Gallery
          .GalleryImage
          .filter(i=>i.Image.Iptc.sdate.substr(0,10)==date)
          .map(i=>{
            return {
             link:i.Image.ImageLink.link,
             sdate:i.Image.Iptc.sdate,
             file_name:i.Image.file_name
            }
          });
        }

        var apiData = getImgLinksByDate(initArray, selectedDate);

        console.log('Api Data:',apiData)

        console.log('Check Date:', initArray, selectedDate);

        var div = document.getElementById('timeline');

        div.innerHTML = "";

        apiData.forEach(function(item) {
          console.log('Item Link:', item.link);
          console.log('Item Sdate:', item.sdate);
          var newTime = moment(item.file_name, ['YYYY_MMDD_HHmmss[.JPG]', 'YYYY_MMDD_HHmmss[.jpg]']).format('YYYY-MM-DD hh:mm:ss A');
          console.log('New time', newTime)
          var div = document.getElementById('timeline');
          div.innerHTML += '<div class="timeline-segment" data-image="' + item.link + '" data-time="' + newTime + '"><div class="timeline-segment-data"><p>' + newTime + '</p></div></div>';
        });

        var image2 = $('.timeline > div:first-child').data('image');
        var time2 = $('.timeline > div:first-child').data('time');

        $('.image-holder').css('background-image', 'url(' + image2 + ')');
        console.log('Image2:', image2);
        $('.time-container').text(time2);
        console.log('Time2:', time2);
        $('.download').attr('href', image2);

      }
    }
    
  };

</script>


<style lang="scss">

  @import '../assets/scss/_variables';
  @import '../assets/scss/_include-media';

  .spinner {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 50px;
    height: 50px;
    margin-left: -25px;
    margin-top: -25px;
    background-image: url('../assets/images/loader.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 48px;
    // background-color: red;
    z-index: 0;
  }

  .header-inner {
    .company {
      font-family: $font-secondary;
      text-align: center;
    }
    @include media('<=medium') {
      .logo {
        display: none;
      }
    }
  }

  .image-holder {
    position: fixed;
    width: 100%;
    height: calc(100% - 160px);
    top: 80px;
    left: 0;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    // background-color: $color-primary;
    // background-color: red;
  }
  
  .timeline {
    position: fixed;
    bottom: 0px;
    left: 0;
    width: 100%;
    height: 80px;
    text-align: center;
    .timeline-segment {
      display: none;
    }
    @include media('>medium') {
      .timeline-segment {
        display: inline-block;
        position: relative;
        height: 30px;
        width: 4px;
        margin-top: 25px;
        border-right: 1px $color-primary solid;
        border-left: 1px $color-primary solid;
        background: $color-primary-comp;
        box-sizing: content-box;
        transition: all 500ms ease-out;
        .timeline-segment-data {
          position: absolute;
          display: none;
          top: -60px;
          left: -150px;
          width: 300px;
          height: 50px;
          background: $color-secondary;
          color: $color-primary;
          line-height: 50px;
          font-family: $font-secondary;
          border-radius: 100px;
        }
        &:hover {
          background: $color-secondary;
          .timeline-segment-data {
            display: block;
          }
        }
        &.active {
          background: $color-secondary;
        }
      }
    }
  }

  .time-container {
    position: fixed;
    bottom: 0;
    left: 40px;
    height: 80px;
    line-height: 80px;
    font-family: $font-secondary;
  }

  .download {
    display: block;
    position: fixed;
    right: 40px;
    bottom: 15px;
    width: 50px;
    height: 50px;
    border: 2px $color-secondary solid;
    border-radius: 50px;
    transition: opacity 300ms ease-in-out;
    img {
      position: absolute;
      top: 8px;
      left: 9px;
    }
    &:hover {
      opacity: 0.7;
    }
  }

  @include media('<=medium') {
    .time-container, .download {
      display: none;
    }
  }

  .hasDatepicker {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 999;
    font-family: $font-secondary;
    background-color: $color-secondary;
    color: $color-primary;
    padding: 20px;
    border-radius: 25px;
    .ui-datepicker-calendar {
      td {
        width: 25px;
        height: 25px;
      }
    }
    .ui-datepicker-current-day {
      a {
        opacity: 0.3;
      }
    }
    .ui-datepicker-today {
      a {
        opacity: 0.3;
      }
    }
    table {
      text-align: center;
    }
    a {
      color: $color-primary;
    }
    .ui-datepicker-title {
      text-align: center;
      padding-bottom: 5px;
    }
    .ui-datepicker-header {
      a {
        display: inline;
        &.ui-datepicker-next {
          float: right;
        }
      }
    }
  }
  
</style>


// WEBPACK FOOTER //
// src/components/gallery.vue